import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-artstamm-template',
  imports: [],
  templateUrl: './artstamm.template.html',
  styleUrls: ['./artstamm.template.css'],
})
export class ArtstammTemplate implements FieldOkItemComponent<any> {
  @Input() item: any;
}
